// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"beschikbare-taxatiebureaus_clickable_label_fix__1Z9gi","text_container":"beschikbare-taxatiebureaus_text_container__1wzBi"};